import config from './config';

export const APP_LOGIN_PARAM = 'login';
export const APP_LOGIN_HINT_PARAM = 'login_hint';

export type SignInAuthorizationParams = {
	login_hint?: string;
	connection?: string;
	screen_hint?: 'signup' | 'login';
};

/** Auth0 authorize params for landing-page email capture and in-app sign-in. */
export function getSignInAuthorizationParams(email?: string): SignInAuthorizationParams {
	const params: SignInAuthorizationParams = {};
	const trimmedEmail = email?.trim();

	if (trimmedEmail) {
		params.login_hint = trimmedEmail;
		params.screen_hint = 'signup';
	}

	if (config.auth0LoginConnection) {
		params.connection = config.auth0LoginConnection;
	}

	return params;
}

export function stripLandingLoginParamsFromUrl(): void {
	const params = new URLSearchParams(window.location.search);
	if (params.get(APP_LOGIN_PARAM) !== '1') {
		return;
	}
	params.delete(APP_LOGIN_PARAM);
	params.delete(APP_LOGIN_HINT_PARAM);
	params.delete('email');
	const qs = params.toString();
	const nextUrl = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash}`;
	window.history.replaceState({}, '', nextUrl);
}
